import React from "react";
import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import AppButton from "components/ui/AppButton";
import { authRoutesUrls } from "Layouts/AuthLayout/PublicRoutes";
import { registerFields as Fields } from "../../utils/fields";
import FieldRenderer from "../../components/field-renderer";

const Step2 = ({ onSubmit = () => { } }) => {
  const { t, i18n } = useTranslation();
  const [form] = Form.useForm();

  return (
    <div className="flex flex-col gap-4">
      <Form
        form={form}
        id="register-form"
        onFinish={onSubmit}
        layout="vertical"
        autoComplete="off"
        name="register-form"
        initialValues={{
          name: "",
          email: "",
          phoneNumber: "",
          password: "",
        }}
      >
        {Fields(t).map((field) => (
          <Form.Item
            key={field.typeKey}
            name={field.typeKey}
            rules={field.rules}
            {...(field.typeKey === "phoneNumber"
              ? { getValueFromEvent: (v) => v ?? "" }
              : {})}
          >
            <FieldRenderer field={field} />
          </Form.Item>
        ))}
      </Form>
      <AppButton type="submit" form="register-form" className="w-full">
        {t("Submit")}
      </AppButton>
      <div className="text-center text-slate-450 font-semibold capitalize">
        {t("Already have an account?")}{" "}
        <Link
          to={authRoutesUrls.login}
          className="text-blue-500 hover:text-blue-600  transition-all duration-300"
        >
          {t("Login")}
        </Link>
      </div>
    </div>
  );
};

export default Step2;
